"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollupStateBadge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const badge_1 = require("../ui/badge");
const VARIANT = {
    PENDING: 'muted',
    IN_PROGRESS: 'warning',
    PUBLISHED: 'success',
    PUBLISHED_REVISED: 'success',
    RECALLED: 'outline',
    PARTIAL: 'warning',
    FAILED: 'destructive',
};
// A PENDING round with no vendor target yet is waiting for a ticked vendor
// (for a recall: a ticked vendor that holds the report) — show that instead
// of a bare PENDING (user, 2026-09-24).
const RollupStateBadge = ({ state, hasTargets = true }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    if (state === 'PENDING' && !hasTargets) {
        return ((0, jsx_runtime_1.jsx)("span", { title: t('components.DistributionsPage.awaitingVendorHint'), children: (0, jsx_runtime_1.jsx)(badge_1.Badge, { variant: "muted", children: t('components.DistributionsPage.awaitingVendor') }) }));
    }
    return (0, jsx_runtime_1.jsx)(badge_1.Badge, { variant: VARIANT[state], children: state });
};
exports.RollupStateBadge = RollupStateBadge;
